export const getSuffix = url => {
  return url && url.indexOf('?') > 0 ? '|' : '?'
}
